import httpManager from "@/app/shared/utils/httpManager";

export async function fetchDashboardData(strategyId, eventsIds = []) {
  let url = `/strategies/${strategyId}/dashboard/?`;

  for (let id of eventsIds) {
    url += `event_management=${id}&`;
  }

  const response = await httpManager.get(url);
  return response.data;
}
